export const SITE = {
  name: "NextChapter4You",
  tagline: "Human-First Coaching. Genuine Career Support.",
  email: "info@nextchapter4you.nl",
  phone: "+31 6 5367 6267",
  phoneRaw: "+31653676267",
  kvk: "42006509",
  registeredAddress: "Eindhoven, Netherlands",
  address: "Eindhoven, Netherlands",
  founder: "Ashutosh Pandey",
  founderTitle: "Performance Coach and Founder",
  founderImage: "/assets/ashutosh-pandey.png",
  coachImage: "/assets/ashutosh-coach.jpeg",
  linkedinBrand: "https://www.linkedin.com/in/nextchapter4you",
  linkedinFounder: "https://www.linkedin.com/in/pande-ashutosh",
  copyrightYear: new Date().getFullYear(),
};

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "Coaching", path: "/professional-coaching" },
  { name: "Outplacement", path: "/expat-outplacement-support" },
  { name: "About", path: "/about-us" },
  { name: "Contact", path: "/contact" },
];

export const LEGAL_LINKS = [
  { name: "Privacy Policy", path: "/privacy-policy" },
  { name: "Cookie Policy", path: "/cookie-policy" },
  { name: "Terms & Conditions", path: "/terms-conditions" },
];
